//basic
import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../../functions/api';

//style
import './CustomerOrderStatusesModify.scss';

//custom components
import CustomInput from '../../../components/basic/input';
import CustomButton from '../../../components/basic/CustomButton'

//material-ui
import {
    Grid,
    Paper,
    CircularProgress,
    createMuiTheme,
    MuiThemeProvider,
    Chip
} from '@material-ui/core';

//other libraries
import ReactQuill from 'react-quill';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Icon from '@mdi/react'
import { mdiPlus, mdiClose } from '@mdi/js'

const TIMEOUT = 3000;

@inject('translate')
@inject('internal')
@observer
export default class CustomerOrderStatusesModify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            editorHtml: "",
            copied: false,
            loadingBtn: false,
            text: ""
        }
    }

    VARIABLES = [
        {
            label: this.props.translate.i18n.MODULES['CUSTOMER-ORDER-STATUSES'].VS,
            value: "vs"
        },
        {
            label: this.props.translate.i18n.MODULES['CUSTOMER-ORDER-STATUSES'].PRICE,
            value: "price"
        },
        {
            label: this.props.translate.i18n.MODULES['CUSTOMER-ORDER-STATUSES'].CUSTOMER_NAME,
            value: "customer_name"
        },
        {
            label: this.props.translate.i18n.MODULES['CUSTOMER-ORDER-STATUSES'].SHOP_LINK,
            value: "shop_link"
        },
        {
            label: this.props.translate.i18n.MODULES['CUSTOMER-ORDER-STATUSES'].ORDER_SUMMARY,
            value: "order_summary"
        },
        {
            label: this.props.translate.i18n.MODULES['CUSTOMER-ORDER-STATUSES'].CONTACT_EMAIL,
            value: "shop_contact_email"
        },
    ]

    modules = {
        toolbar: [
            ['bold', 'italic', 'underline'], // 'strike', 'blockquote'
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{'list': 'ordered'}, {'list': 'bullet'}], // {'indent': '-1'}, {'indent': '+1'}
            [{ "size": [ 'small', false, 'large', 'huge' ]}],
            [{"color": []}, {background: []}],
            [{"align": []}],
            ['link']
        ],
        clipboard: {
          // toggle to add extra line breaks when pasting HTML:
            matchVisual: false,
        }
      }
      /*
       * Quill editor formats
       * See https://quilljs.com/docs/formats/
       */
    formats = [
        'bold', 'italic', 'underline',
        'header',
        'list', 'bullet',
        'size',
        'color',
        'background',
        'align',
        'link'
    ]

    componentDidMount() {
        let actionEdit = this.props.match.params.hasOwnProperty("id")

        this.props.internal.setRoute( this.props.history, this.props.location.pathname)
        this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.LIST_CUSTOMER_ORDER_STATUSES )

        if(actionEdit) {
            Promise.all([
                this.loadStateDetail(this.props.match.params.id ),
            ]).then(() => {
                this.setState({loading: false})
            })
        }
        else {
            this.setState({loading: false})
        }
    }

    loadStateDetail = async(id) => {
        let load_data = await api({
            method: 'GET',
            url: `lists/customer-order-statuses/${id}`,
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.setState({editorHtml: load_data.data.data.email})
            this.props.internal.setDataForTable(load_data.data.data)
        }
        else {
            this.props.internal.setRoute( this.props.history, this.props.location.pathname);
            this.props.internal.pushRoute('/customer-order-statuses')
        }
    }

    handleChange = (field, val) => {
        this.setState({[field]: val})
    }

    onCopy = () => {
        this.setState({copied: true});
        this.props.internal.setSnackbar(this.props.translate.i18n.MODULES.TEMPLATES.VARIABLE_WAS_COPPIED_TO_CLIPBOARD, true)
    };

    handleCreateUpdate = () => {
        if(this.name.state.value !== "" && this.quill.getEditor().getText() !== '') {
            if(this.props.match.params.id) {
                this.updateStatus(this.props.match.params.id)
            }
            else {
                this.creteStatus()
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
        }
    }

    updateStatus = async(id) => {
        this.setState({loadingBtn: true})
        let update_data = await api({
            url: `lists/customer-order-statuses/${id}`,
            method: "PATCH",
            authorization: this.props.internal.user.access_token,
            params: {
                name: this.name.state.value,
                email: this.state.editorHtml,
                text: this.text.state.value
            }
        });

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.props.internal.pushRoute("/customer-order-statuses")
        }

        this.setState({loadingBtn: false})
    }

    creteStatus = async() => {
        this.setState({loadingBtn: true})
        let update_data = await api({
            url: `lists/customer-order-statuses`,
            method: "POST",
            authorization: this.props.internal.user.access_token,
            params: {
                name: this.name.state.value,
                email: this.state.editorHtml,
                text: this.text.state.value
            }
        });

        if(update_data.success === true || (update_data.success === false && update_data.status === 201)) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.props.internal.pushRoute("/customer-order-statuses")
        }

        this.setState({loadingBtn: false})
    }

    goBack = () => {
        this.props.internal.pushRoute("/customer-order-statuses")
    }

    render () {
        return (
            <div className={'shopDetailContainer status'}>
                <div className={'flex header'}>
                    <h1 className={'title'}>{this.props.match.params.id ? this.props.translate.i18n.MODULES['CUSTOMER-ORDER-STATUSES'].EDIT_STATUS_TITLE : this.props.translate.i18n.MODULES['CUSTOMER-ORDER-STATUSES'].NEW_STATUS_TITLE}</h1>
                    <div className={'back-btn'} onClick={this.goBack}>
                        <Icon path={mdiClose} size={1}/>
                    </div>
                </div>
                <div className="content">
                    {this.state.loading
                    ?
                    <CircularProgress className={'circular-progress'} />
                    :
                    <Grid container spacing={16} >
                        <Grid item xs={12} sm={4}>
                            <Grid container spacing={16}>
                                <Grid item xs={12}>
                                    <Paper className={'paperContainer'}>
                                        <CustomInput
                                            ref={ref => (this.name = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.NAME}
                                            value={toJS(this.props.internal.dataForTable.name)}
                                            id={"name"}
                                            className={"w-100"}
                                            change={(val) => this.handleChange('name', val)}
                                            required
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12}>
                                    <Paper className={'paperContainer'}>
                                    <p className={'variablesTitle'}>{this.props.translate.i18n.MODULES['CUSTOMER-ORDER-STATUSES'].VARIABLES}</p>
                                    {this.VARIABLES.map((item, index) => {
                                        return (
                                            <CopyToClipboard key={index} onCopy={this.onCopy} text={`{${item.value}}`}>
                                                <Chip
                                                    className={'variableChip'}
                                                    label={item.label}
                                                    // onClick={() => this.handleClickOnVariable(variable)}
                                                    // onDelete={() => this.handleDeletePlaceholder(variable.id)}
                                                />
                                            </CopyToClipboard>
                                        );
                                    })}
                                    
                                    </Paper>
                                </Grid>
                            </Grid>
                            
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Paper className={'paperContainer'}>
                                <div className={'saveBtnContainer'}>
                                    <span>{this.props.translate.i18n.MODULES.SHOPS.EMAIL_TITLE}</span>
                                    <CustomButton
                                        progressBar={this.state.loadingBtn}
                                        onClick={this.handleCreateUpdate}
                                        mystyle={'btn-orange-bg height-36'}
                                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                                        justText
                                    >
                                    </CustomButton>
                                </div>
                                <ReactQuill
                                    className={'orderStateEditor'}
                                    theme="snow"
                                    onChange={(val) => this.handleChange('editorHtml', val)}
                                    value={this.state.editorHtml}
                                    // modules={this.modules}
                                    // formats={this.formats}
                                    bounds={'.app'}
                                    placeholder={''}
                                    ref={ref => this.quill = ref}
                                />
                                <br/>
                                <CustomInput
                                    ref={ref => (this.text = ref)}
                                    text={this.props.translate.i18n.MODULES.SHOPS.SMS_TITLE}
                                    value={toJS(this.props.internal.dataForTable.text)}
                                    id={"text"}
                                    className={"w-100"}
                                    change={(val) => this.handleChange('text', val)}
                                    required
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/CustomerOrderStatuses/CustomerOrderStatusesModify/CustomerOrderStatusesModify.jsx